export default __webpack_public_path__ + "static/hero-image-7-baa9eaff3f0e6ca191acb37825a56be2.png";